import { GetToolUsageResponse, useGetCurrentUserQuery } from "@/store/services/supabase";
import { useIsOwner } from "@/utils/hooks/useIsOwner";
import ArrowRightOutlined from "@ant-design/icons/es/icons/ArrowRightOutlined";
import * as Sentry from "@sentry/nextjs";
import { Alert, Button } from "antd";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import Markdown from "react-markdown";
const DetailsButton = () => <Link href="/settings/org/usage" target="_blank" rel="noreferrer" data-sentry-element="Link" data-sentry-component="DetailsButton" data-sentry-source-file="LargeSiteScreenFairUseWarning.tsx">
    <Button size="small" type="text" data-sentry-element="Button" data-sentry-source-file="LargeSiteScreenFairUseWarning.tsx">
      Details {<ArrowRightOutlined />}
    </Button>
  </Link>;
const LargeSiteScreenFairUseWarning = ({
  data
}: {
  data: GetToolUsageResponse;
}) => {
  const {
    t
  } = useTranslation("tools", {
    keyPrefix: "comprehensive.largeSite.uploadLimitAlert"
  });
  const isOwner = useIsOwner();
  const {
    data: currentUser
  } = useGetCurrentUserQuery();
  const currentUsage = data.singleQuotaMode ? data.singleQuotaUsage : data.portfolioInsights;
  if (!currentUsage || typeof currentUsage.quota !== "number" || currentUsage.quota === 0) {
    Sentry.captureException("largeSiteScreenFairUsageWarning", {
      tags: {
        section: "Quota Limit Error"
      },
      extra: {
        userId: currentUser?.id,
        toolUsage: data,
        currentUsage: currentUsage
      }
    });
    return <Alert type="error" className="mb-4" showIcon message={<Markdown>{isOwner ? t("owner.refresh") : t("user.refresh")}</Markdown>} />;
  }
  const remaining = data.quotas.largeSite.quota - data.usage.largeSite;
  return <>
      {remaining === 1 && <Alert type="warning" className="mb-4" showIcon action={isOwner && <DetailsButton />} message={<Markdown>{isOwner ? t("owner.warning") : t("user.warning")}</Markdown>} />}

      {remaining <= 0 && <Alert type="error" className="mb-4" showIcon action={isOwner && <DetailsButton />} message={<Markdown>{isOwner ? t("owner.error") : t("user.error")}</Markdown>} />}
    </>;
};
export default LargeSiteScreenFairUseWarning;